<script lang="ts">
	import type { Device } from 'src/types/Device';
	import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';
	import type { DeviceSettingsG2 } from 'src/types/DeviceSettings';
	import CameraVideoPlayer from '../CameraPlayer/CameraVideoPlayer.svelte';
	import LastRecordings from './LastRecordings.svelte';
	import CameraCloudStoragePromoBanner from 'src/components/Settings/CameraCloudStorage/CameraCloudStoragePromoBanner.svelte';

	export let device: Device, statuses, status: DeviceStatusG2, settings: DeviceSettingsG2;
</script>

<div class="flex-full-height flex-column gap-m">
	<CameraVideoPlayer {device} {status} {settings} />
	<LastRecordings deviceId={device.id} />
	<CameraCloudStoragePromoBanner deviceId={device?.id} />
</div>
